import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "ap-southeast-1_V4o7awr18",
  ClientId: "4mrfm6k77766tbcs2pqee4uf25",
};

export default new CognitoUserPool(poolData);
